import * as React from 'react';

export default function SitemarkIcon() {
  return (
    <img src="./assets/images/logo.png" alt="Trusted Reviews" width="100" height="45" title="Trusted Reviews"/> 
  );
}
